import MicroModal from 'micromodal';

const selectors = {
  ageGate: '[data-age-gate]',
  underageButton: '[data-underage-button]',
  confirmButton: '[data-overage-button]',
  newsletterModal: '[data-newsletter-modal]',
  newsletterClose: '[data-micromodal-close]',
  closeSubscribe: '[data-close-subscribe-gate]',
};

const settings = {
  sessionKey: 'wlcrOPPAgeConfirmation',
};

const modalStorage = window.localStorage;

const redirectTo = 'https://www.google.com/';

const handleUnderageClick = () => {
  window.location = redirectTo;
};

const handleConfirmClick = () => {
  modalStorage.setItem(settings.sessionKey, true);
  MicroModal.close('age-gate');
  MicroModal.show('subscribe-gate', {
    disableScroll: true,
    disableFocus: true,
  });
};

const openAgeGate = () => {
  const ageGate = document.querySelector(selectors.ageGate);
  const underageButton = ageGate.querySelector(selectors.underageButton);
  const confirmButton = ageGate.querySelector(selectors.confirmButton);
  MicroModal.init();
  MicroModal.show('age-gate', {
    disableScroll: true,
    disableFocus: true,
  });
  underageButton.addEventListener('click', handleUnderageClick);
  confirmButton.addEventListener('click', handleConfirmClick);
};

const handleAgeGate = () => {
  const ageGate = document.querySelector(selectors.ageGate);

  if (!ageGate) return;

  const ageConfirmation = modalStorage.getItem(settings.sessionKey);

  if (ageConfirmation !== 'true') {
    openAgeGate();
  }
};

const subscribeClose = () => {
  const closeSubscribe = document.querySelector(selectors.closeSubscribe);
  if (!closeSubscribe) return;
  closeSubscribe.addEventListener('click', () => {
    MicroModal.close('subscribe-gate');
  });
};

const init = () => {
  handleAgeGate();
  subscribeClose();
};

init();
